/* eslint-disable camelcase */
// this file contains non-Launchpad related services for macmillan launch service-based launches
// this includes anything LCRP related that is launchy

import fetch from 'isomorphic-fetch'
import _ from 'lodash'
import { getCookie } from '../middleware/macmillan'
import logToLoggly from '../../shared/lib/loggly'
import { buildLearningCurve, applyConfigOverrides } from './legacy/legacyActivityBuilder'
import { finishInitialization } from './legacy/legacyArgaService'
import calculateTime from '../../lcrp/lib/calculateTime'
import params from './params'
const config = params()

export function restoreMacmillanData (activity, preload) {
  Object.assign(activity.studentData, preload)
  activity.studentData.user_id_type = 'macmillan'
  activity.studentData.assignment_id = preload.assignment_id
  activity.config.itemId = preload.assignment_id

  // Ignore other assignment settings
  if (preload.assignment_settings &&
    preload.assignment_settings.targetScore && preload.assignment_settings.excludedTopicIds) {
    activity.config.scoreTarget = preload.assignment_settings.targetScore
    activity.config.topicsExcluded = preload.assignment_settings.excludedTopicIds
  }

  return activity
}

/* lcrp */

export function isLcrpAvailable () {
  return window.location.href.indexOf('/lcrp') > -1
}

export function saveMacmillanAssignmentSettings (activity, userData) {
  if (!userData) {
    return false
  }

  const assignmentId = userData.assignment_id
  const settings = {}
  settings.targetScore = activity.score.scoreTarget
  settings.excludedTopicIds = activity.config.topicsExcluded

  fetch('../api/v1/assignment.php', {
    method: 'POST',
    body: JSON.stringify({
      assignment_settings: settings,
      set_assignment_settings: 1,
      assignment_id: assignmentId,
      resourceId: assignmentId,
      token: getCookie('id_token')
    })
  }).then(function (response) {
    console.log('Macmillan Assignment Settings Saved')
  })
}

/* standalone data */
export function constructRosterObjects (activity, rosterData) {
  let grade = 0
  let completedTimestamp = null

  if (typeof rosterData !== 'object') {
    return false
  }

  for (const convertKey in rosterData) {
    rosterData[convertKey].activity_state = JSON.parse(rosterData[convertKey].activity_state)
    if (rosterData[convertKey].lcrp_progress != null) {
      rosterData[convertKey].lcrp_progress = JSON.parse(rosterData[convertKey].lcrp_progress)
    }
  }

  const rosterObjects = {
    studentData: {
      user_id_array: [],
      user_firstName_array: [],
      user_lastName_array: [],
      user_rights_array: [],
      user_grade_array: [],
      user_completed_timestamp_array: [],
      user_activity_scores: [],
      user_questions_received: [],
      participating_students: rosterData.length,
      started_students: 0,
      completed_students: 0
    },
    students: []
  }

  for (let i = 0; i < activity.allTopics.length; i++) {
    activity.allTopics[i].class_points_available = 0
    activity.allTopics[i].class_points_earned = 0
    activity.allTopics[i].class_questions_received = 0

    for (const classKey in rosterData) {
      if (activity.config.topicsExcluded.indexOf(i) !== -1) {
        continue
      }

      if (rosterData[classKey].activity_state.tp !== undefined &&
        activity.allTopics.length !== rosterData[classKey].activity_state.tp.length) {
        // Move loggly to prevent in-necessary calls
        // logToLoggly('macmillan.js: Student number of submitted topics do not match number of topics for quiz', 'WARN')
        continue
      }
      if (rosterData[classKey].activity_state.score >= rosterData[classKey].activity_state.target &&
        isLcrpAvailable()) {
        activity.allTopics[i].class_points_available += rosterData[classKey].activity_state.tp[i].pa
        activity.allTopics[i].class_points_earned += rosterData[classKey].activity_state.tp[i].pe
        activity.allTopics[i].class_questions_received += rosterData[classKey].activity_state.tp[i].qr
      } else if (!isLcrpAvailable()) {
        activity.allTopics[i].class_points_available += rosterData[classKey].activity_state.tp[i].pa
        activity.allTopics[i].class_points_earned += rosterData[classKey].activity_state.tp[i].pe
        activity.allTopics[i].class_questions_received += rosterData[classKey].activity_state.tp[i].qr
      }
    }
  }

  for (const key in rosterData) {
    // eslint-disable-next-line no-prototype-builtins
    if (rosterData.hasOwnProperty(key)) {
      let qr = 0

      grade = rosterData[key].activity_state.score >= rosterData[key].activity_state.target ? 100 : 0
      completedTimestamp = rosterData[key].completed_timestamp

      rosterObjects.studentData.started_students++

      if (grade === 100) {
        rosterObjects.studentData.completed_students++
      }

      const activityState = rosterData[key].activity_state

      // old records might not have quizTimes Array
      if (!activityState.quizTimes) {
        const obj = {}
        if (activityState.startQuizTime) {
          obj.startQuizTime = activityState.startQuizTime
        }
        if (activityState.completeQuizTime) {
          obj.completeQuizTime = activityState.completeQuizTime
        }
        activityState.quizTimes = [obj]
      }

      // same logic for rt in activity_state
      if (activityState.rt && !activityState.rt.quizTimes) {
        const obj = {}
        if (activityState.rt.startQuizTime) {
          obj.startQuizTime = activityState.startQuizTime
        }
        if (activityState.rt.completeQuizTime) {
          obj.completeQuizTime = activityState.completeQuizTime
        }
        activityState.rt.quizTimes = [obj]
      }

      rosterObjects.students.push({
        id: rosterData[key].email,
        firstName: rosterData[key].first_name,
        lastName: rosterData[key].last_name,
        questionsReceived: rosterData[key].activity_state.qr,
        score: rosterData[key].activity_state.score,
        completion: rosterData[key].activity_state.score,
        activity_state: activityState,
        grade,
        dueDate: '',
        index: key,
        completedTimestamp,
        lcrp_progress: rosterData[key].lcrp_progress,
        timeOnTask: rosterData[key].time_on_task,
        startedTimestamp: rosterData[key].started_timestamp
      })

      rosterObjects.studentData.user_id_array.push(rosterData[key].email)
      rosterObjects.studentData.user_firstName_array.push(rosterData[key].first_name)
      rosterObjects.studentData.user_lastName_array.push(rosterData[key].last_name)
      rosterObjects.studentData.user_rights_array.push('1_student')
      rosterObjects.studentData.user_grade_array.push(grade)
      rosterObjects.studentData.user_completed_timestamp_array.push(completedTimestamp)
      rosterObjects.studentData.user_activity_scores.push(rosterData[key].activity_state.score)

      // rosterObjects.allTopics.class_questions_received += rosterData[key].activity_state.qr
      // rosterObjects.topics = []
      let t = {}
      for (let i = 0; i < activity.allTopics.length; i++) {
        // rosterObjects.allTopics.class_points_available += rosterData[key].activity_state.tp[i].pa
        // rosterObjects.allTopics.class_points_earned += rosterData[key].activity_state.tp[i].pe

        if (activity.config.topicsExcluded.indexOf(i) !== -1) {
          continue
        }

        if (rosterData[key].activity_state.tp !== undefined &&
          activity.allTopics.length !== rosterData[key].activity_state.tp.length) {
          logToLoggly('macmillan.js: Student number of submitted topics do not match number of topics for quiz', 'WARN')
          continue
        }
        t = activity.allTopics[i]

        qr += t.class_questions_received
        t.pa_arr.push(rosterData[key].activity_state.tp[i].pa)
        t.pe_arr.push(rosterData[key].activity_state.tp[i].pe)

        // rosterObjects.topics.push(t)
      }
      rosterObjects.studentData.user_questions_received.push(qr)
    }
  }

  return rosterObjects
}

export function calculateCourseDashboardData (activity, rosterData) {
  if (!rosterData.length) {
    const dashboardData = {
      studentDataAllAttempts: [],
      accuracyAverageAllAttempts: 0,
      accuracyDataAllAttempts: [],
      accuracyDataFirstAttempts: [],
      accuracyAverageFirstAttempts: 0,
      averageStudentAccessTime: 0,
      averageStudentQuestionTime: 0,
      accuracyRanges: {
        lowAccuracyPercent: 0,
        mediumAccuracyPercent: 0,
        highAccuracyPercent: 0
      },
      assignmentOverview: []
    }
    return dashboardData
  }
  let assignmentAccuracy = 0
  let totalPointsEarned = 0
  let currentStudentPointsEarned = 0
  let totalPointsAvailable = 0
  let currentStudentPointsAvailable = 0
  let currentStudentAccuracy = 0
  let currentStudentName = ''
  let totalQuestionTime = 0
  let totalReadingTime = 0
  let totalQuestionsRecieved = 0
  const allStudentAccuracyAvgArray = []
  const allQuizAttemptScoreArray = []
  let singleQuizPointsEarned = 0
  let singleQuizPointsAvailable = 0
  let singleQuizScore = 0
  let allStudentFirstAttemptAverage = 0
  const allStudentFirstAttemptArray = []
  let numCompletedStudents = 0
  let numCompletedFirstAttempts = 0

  // big loops; we need to get accuracy per student per topic per quiz and retake
  for (let i = 0; i < rosterData.length; i++) {
    rosterData[i].activity_state = rosterData[i].activity_state
    currentStudentName = rosterData[i].first_name + ' ' + rosterData[i].last_name
    // get original quiz result accuracy numbers for this student
    // eslint-disable-next-line no-loop-func
    _.each(rosterData[i].activity_state.tp, (topic, index) => {
      totalPointsEarned += topic.pe
      currentStudentPointsEarned += topic.pe
      singleQuizPointsEarned += topic.pe
      totalPointsAvailable += topic.pa
      currentStudentPointsAvailable += topic.pa
      singleQuizPointsAvailable += topic.pa
    })
    // student individual first attempt score
    singleQuizScore = Math.round(100 * (singleQuizPointsEarned / singleQuizPointsAvailable))
    if (!isNaN(singleQuizScore)) {
      allQuizAttemptScoreArray.push(singleQuizScore)
      if (rosterData[i].activity_state.score >= rosterData[i].activity_state.target) {
        allStudentFirstAttemptArray.push(singleQuizScore)
        allStudentFirstAttemptAverage += singleQuizScore
        numCompletedStudents++
      }
    }
    singleQuizPointsEarned = 0
    singleQuizPointsAvailable = 0
    singleQuizScore = 0

    // get most recent quiz retake accuracy numbers for this student
    if ((rosterData[i].activity_state.rt)) {
      // eslint-disable-next-line no-loop-func
      _.each(rosterData[i].activity_state.rt.tp, (topic, index) => {
        totalPointsEarned += topic.pe
        currentStudentPointsEarned += topic.pe
        singleQuizPointsEarned += topic.pe
        totalPointsAvailable += topic.pa
        currentStudentPointsAvailable += topic.pa
        singleQuizPointsAvailable += topic.pa
      })
    }

    // student individual most recent retake score
    singleQuizScore = Math.round(100 * (singleQuizPointsEarned / singleQuizPointsAvailable))
    if (!isNaN(singleQuizScore)) {
      allQuizAttemptScoreArray.push(singleQuizScore)
    }
    singleQuizPointsEarned = 0
    singleQuizPointsAvailable = 0
    singleQuizScore = 0

    // get all other quiz retake accuracy numbers for this student
    if (!(!rosterData[i].lcrp_progress) && !(!rosterData[i].lcrp_progress.ra)) {
      // eslint-disable-next-line no-loop-func
      _.each(rosterData[i].lcrp_progress.ra, (rttObj, index) => {
        _.each(rttObj.tp, (topic, index) => {
          totalPointsEarned += topic.pe
          currentStudentPointsEarned += topic.pe
          singleQuizPointsEarned += topic.pe
          totalPointsAvailable += topic.pa
          currentStudentPointsAvailable += topic.pa
          singleQuizPointsAvailable += topic.pa
        })

        // student individual retake score
        singleQuizScore = Math.round(100 * (singleQuizPointsEarned / singleQuizPointsAvailable))
        if (!isNaN(singleQuizScore)) {
          allQuizAttemptScoreArray.push(singleQuizScore)
        }
        singleQuizPointsEarned = 0
        singleQuizPointsAvailable = 0
        singleQuizScore = 0
      })
    }
    currentStudentAccuracy = Math.round(100 * (currentStudentPointsEarned / currentStudentPointsAvailable))
    allStudentAccuracyAvgArray.push({ [currentStudentName]: currentStudentAccuracy })
    currentStudentPointsEarned = 0
    currentStudentPointsAvailable = 0

    const {
      startQuizTime,
      completeQuizTime,
      quizTimes,
      score,
      target
    } = rosterData[i].activity_state
    let quizTime = 0

    // only consider time if a student has completed a first attempt
    if (score >= target) {
      // now check if activity_state has the old or new time format
      if (quizTimes) {
        quizTime = calculateTime(quizTimes)
      } else if (!quizTimes && startQuizTime && completeQuizTime) {
        quizTime = completeQuizTime - startQuizTime
      }
      // now increment the number of completed first attempts and qr to get accurate average
      numCompletedFirstAttempts++
      totalQuestionsRecieved += rosterData[i].activity_state.qr
    }

    rosterData[i].activity_state.total_question_time = quizTime

    totalQuestionTime += rosterData[i].activity_state.total_question_time
    if (rosterData[i].lcrp_progress && rosterData[i].lcrp_progress.fa &&
      rosterData[i].lcrp_progress.fa.totalReadingTimeInMilliseconds) {
      // eslint-disable-next-line no-unused-vars
      totalReadingTime += rosterData[i].lcrp_progress.fa.totalReadingTimeInMilliseconds
    }
  }
  assignmentAccuracy = Math.round(100 * (totalPointsEarned / totalPointsAvailable))
  allStudentFirstAttemptAverage = Math.round(allStudentFirstAttemptAverage / numCompletedStudents)
  const dashboardData = {
    studentDataAllAttempts: allStudentAccuracyAvgArray, // student name
    accuracyAverageAllAttempts: assignmentAccuracy, // avg across all attempts
    accuracyDataAllAttempts: allQuizAttemptScoreArray,
    accuracyDataFirstAttempts: allStudentFirstAttemptArray,
    accuracyAverageFirstAttempts: allStudentFirstAttemptAverage,
    averageStudentAccessTime: (totalQuestionTime / numCompletedFirstAttempts),
    averageStudentQuestionTime: (totalQuestionTime / totalQuestionsRecieved),
    accuracyRanges: getAccuracyRanges(allStudentFirstAttemptArray),
    assignmentOverview: getAssignmentOverview(rosterData)
  }
  return dashboardData
}

// this is used to get a student's topical performance for each assignment in the course
export async function getStudentTopicalPerformance (rosterData, assignmentOverview, config) {
  // get all of the assignment ids in course
  const allAssignments = _.map(rosterData, assignment => {
    return {
      file: assignment.activity_file,
      id: assignment.assignment_id,
      settings: assignment.assignment_settings
    }
  })

  const uniqAllAssignments = _.uniqBy(allAssignments, (assigment) => assigment.id)

  const activityHostname = config.ACTIVITY_HOSTNAME || ''
  const activityBasePath = config.ACTIVITY_BASE_PATH || 'learningcurve_activity_config/'

  // concurrently fetch all the activity files
  const activityPromises = _.map(uniqAllAssignments, ({ file, id, settings }) => {
    const endpoint = activityHostname + activityBasePath + (file || config.DEFAULT_ACTIVITY_FILE) + '.txt'
    return fetch(endpoint).then(res => res.text())
  })

  // after all fetchs have resolved, build LC objects with them
  try {
    const activityData = await Promise.all([...activityPromises])
    const activities = _.map(activityData, (text, idx) => {
      const assignment = uniqAllAssignments[idx]
      const activity = buildLearningCurve(text, config)
      const preload = {
        assignment_id: assignment.id,
        assignment_settings: assignment.settings ? JSON.parse(assignment.settings) : null
      }
      restoreMacmillanData(activity, preload)
      applyConfigOverrides(activity)
      finishInitialization(activity)
      return activity
    })
    const topicalScores = _.reduce(activities, (acc1, item) => {
      const matchingActivities = _.filter(rosterData, obj => obj.assignment_id === item.studentData.assignment_id)

      let topics
      _.each(matchingActivities, (activity) => {
        const {
          activity_state: {
            tp,
            score,
            target
          }
        } = activity

        if (!topics) {
          topics = _.cloneDeep(tp)
          if (score < target) {
            _.each(topics, (topic, idx) => {
              topics[idx].pa = 0
              topics[idx].pe = 0
            })
          }
        } else {
          _.each(tp, (topic, idx) => {
            topics[idx].pa += score < target ? 0 : topic.pa
            topics[idx].pe += score < target ? 0 : topic.pe
          })
        }
      })

      // Currently only picks out the topic for the first student
      const scores = item.topics.reduce((acc2, topic, idx) => {
        const { label } = topic
        let score = Math.round((topics[idx].pe / topics[idx].pa) * 100)
        score = isNaN(score) ? 0 : score
        acc2[label] = {
          score,
          hasQuestions: topic.totalQuestions > 0
        }
        return acc2
      }, {})
      const matchingIdx = _.findIndex(acc1, overview => overview.assignmentId === item.studentData.assignment_id)
      acc1[matchingIdx].topicalPerformance = scores
      return acc1
    }, assignmentOverview)

    return Promise.resolve(topicalScores)
  } catch (error) {
    return Promise.reject(error)
  }
}

// this is used for the breakdown of assignments on instructor dashboard
function getAssignmentOverview (rosterData) {
  const groups = _.groupBy(rosterData, 'assignment_id')
  return _.map(groups, (students, id) => {
    const assignmentData = {
      assignmentId: id,
      title: students[0].activity_title,
      file: students[0].activity_file,
      courseId: students[0].course_id,
      avgFirst: getAvgFirstAttemptForAssignment(students),
      topicalPerformance: null,
      numRetakes: isLcrpAvailable() ? getNumRetakes(students) : 0
    }
    if (isLcrpAvailable()) {
      assignmentData.retakeGain = getRetakeGain(
        students,
        assignmentData.avgFirst,
        assignmentData.numRetakes
      )
    } else {
      assignmentData.retakeGain = 0
    }
    return assignmentData
  })
}

// determine the retake gain
function getRetakeGain (students, avgFirst, numRetakes) {
  let classPointsAvailable = 0
  let classPointsEarned = 0

  // if there are no retakes, we cannot calculate the gain.
  if (numRetakes < 1) return null

  _.each(students, student => {
    const { activity_state: { rt }, lcrp_progress } = student
    const retakeHistory = lcrp_progress

    // check if latest retake is completed
    if (rt && rt.score >= rt.target) {
      _.each(rt.tp, topic => {
        classPointsEarned += topic.pe
        classPointsAvailable += topic.pa
      })
    } else if (retakeHistory && retakeHistory.ra && retakeHistory.ra.length > 0) {
      // if current retake is not completed, check ra array and use last completed retake score
      const lastCompletedRetake = _.last(retakeHistory.ra)
      _.each(lastCompletedRetake.tp, topic => {
        classPointsEarned += topic.pe
        classPointsAvailable += topic.pa
      })
    }
  })

  // the average score of students' most recent retake.
  let retakeAvg = Math.round((classPointsEarned / classPointsAvailable) * 100)
  if (isNaN(retakeAvg)) {
    retakeAvg = 0
  }

  // return the difference
  return retakeAvg - avgFirst
}

// get the accuracy of first attempt scores for a single assignment, not all
function getAvgFirstAttemptForAssignment (students) {
  let classPointsAvailable = 0
  let classPointsEarned = 0
  let numFirstAttemptsCompleted = 0

  _.each(students, student => {
    const { activity_state: { score, target, tp } } = student
    // only calculate FA score if student has completed activity
    if (score >= target) {
      numFirstAttemptsCompleted++

      // loop through tp array, ignore topics that have no questions (i.e. introduction sections)
      _.each(tp, topic => {
        const { pa, pe, qr } = topic
        if (qr > 0) {
          classPointsAvailable += pa
          classPointsEarned += pe
        }
      })
    }
  })

  // if no students have finished a first attempt, just display a dash in Component
  if (numFirstAttemptsCompleted === 0) {
    return null
  }
  const average = Math.round((classPointsEarned / classPointsAvailable) * 100)
  return isNaN(average) ? 0 : average
}

// used to generate number of total retakes for each assignment
function getNumRetakes (students) {
  let numRetakes = 0
  _.each(students, student => {
    const { activity_state: { rt }, lcrp_progress } = student

    // check if most recent retake is competed
    if (rt && rt.score >= rt.target) {
      numRetakes++
    }

    // Check ra for historical retakes
    const retakeHistory = lcrp_progress
    if (retakeHistory && retakeHistory.ra) {
      numRetakes += retakeHistory.ra.length
    }
  })
  return numRetakes
}

// this is used for the pie chart on the instructor dashboard
export function getAccuracyRanges (firstAttempts) {
  let lowAccuracy = 0
  let mediumAccuracy = 0
  let highAccuracy = 0
  for (let i = 0; i < firstAttempts.length; i++) {
    if (firstAttempts[i] >= 90) {
      highAccuracy++
    } else if (firstAttempts[i] >= 70) {
      mediumAccuracy++
    } else {
      lowAccuracy++
    }
  }
  const accuracyRanges = {
    lowAccuracyPercent: Math.round(100 * (lowAccuracy / firstAttempts.length)),
    mediumAccuracyPercent: Math.round(100 * (mediumAccuracy / firstAttempts.length)),
    highAccuracyPercent: Math.round(100 * (highAccuracy / firstAttempts.length))
  }
  return accuracyRanges
}
